<template><div class="main">
  <sticky-bar @back="$router.push(`/s/f/${fid}`)">
    {{ fleet && fleet.name || 'Loading...' }}
    <small>Points of Interest</small>
  </sticky-bar>
  <div v-if="!fleet" class="padded">
    <Loading />
  </div>
  <div v-else class="poi-settings"><div>
    <div class="config" ref="config"><div><div>
      <div class="poi-list">
        <a
            v-for="p in pois"
            :key="`poi-${p.id}`"
            href="#"
            @click.prevent="selectPoi(p)"
            v-html="p.name"
            :class="{selected:(p&&p.id)===(poi&&poi.id)}"
          />
        <a
            class="add"
            href="#"
            @click.prevent="selectPoi(true)"
          ><span class="material-icons">add</span></a>
      </div>
      <div class="edit-poi" v-if="poi">
        <div class="poi-row">
          <label>Name:</label>
          <input v-model="poi.name" :class="{changed:nameChanged}" />
          <div>
            <button @click="save" :class="{changed:anyChanged}">Save</button>
            <button @click="del" >Delete</button>
          </div>
        </div>
        <div class="poi-row">
          <label>Type:</label>
          <div>
            <button :class="{selected:poi.model[0][0] === 'point'}" @click="setType('point')">Point</button>
            <button :class="{selected:poi.model[0][0] === 'circle'}" @click="setType('circle')">Circle</button>
          </div>
        </div>
      </div>
    </div></div></div>
    <g-map :showUnits="false" :fleet="fleet" :poi="poi" ref="map" />
  </div></div>
</div></template>
<script>
import { mapState } from 'vuex'
import GMap from '../../GMap'
import Loading from '../../Loading'
import StickyBar from '../../StickyBar'
export default {
  name: 'poi-settings',
  components: { GMap, Loading, StickyBar },
  props: { fid: { default: null } },
  data() {
    return {
      poi: null,
      mods: {},
      pendingPoi: null,
    }
  },
  mounted() {
    this.$store.commit('setFilterFleetId', null)
  },
  computed: {
    fleet() { return (this.fid !== null) && this.$store.getters.fleets[this.fid] || null },
    ...mapState(['selectedPoi']),
    pois() {
      return this.fleet.pois
    },
    savedPoi() {
      if (!this.poi || !('id' in this.poi))
        return null
      for (const poi of this.pois)
        if (this.poi.id === poi.id)
          return poi
      return null
    },
    nameChanged() {
      if (!this.savedPoi) return true
      return this.savedPoi.name !== this.poi.name
    },
    anyChanged() {
      if (this.nameChanged) return true
      if (this.poi.model.length !== this.savedPoi.model.length) return true
      for (let i=0; i<this.poi.model.length; i++)
        if (this.shapeChanged(i))
          return true
      return false
    },
  },
  methods: {
    selectPoi(poi) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.$refs.config.scrollTop = this.$refs.config.scrollHeight
        })
      })
      if (poi === true && (!this.poi || this.poi.id)) {
        let c = this.$refs.map.map.getCenter()
        this.poi = {
          name: 'New POI',
          model: [['point',c.lat(),c.lng()]],
        }
        return
      }
      if ((poi && poi.id) === (this.poi && this.poi.id)) {
        if (!this.anyChanged) {
          this.poi = null
        }
        return
      }
      if (Object.keys(this.mods).length) {
        this.pendingPoi = poi
      } else {
        this.poi = JSON.parse(JSON.stringify(poi))
        if (this.poi.model.length === 0) {
          let c = this.$refs.map.map.getCenter()
          this.poi.name = 'New POI'
          this.poi.model = [['point',c.lat(),c.lng()]]
        }
      }
    },
    shapeChanged(i) {
      if (!this.savedPoi) return true
      if (i >= this.savedPoi.model.length) return true
      return JSON.stringify(this.savedPoi.model[i]) !== JSON.stringify(this.poi.model[i])
    },
    getMinDimension() {
      const b = this.$refs.map.getBounds(),
        ne = b.getNorthEast(),
        sw = b.getSouthWest(),
        c = this.$refs.map.map.getCenter(),
        d = this.$refs.map.google.maps.geometry.spherical.computeDistanceBetween,
        LatLng = this.$refs.map.google.maps.LatLng,
        p1 = new LatLng({lat:ne.lat(), lng:c.lng()}),
        p2 = new LatLng({lat:sw.lat(), lng:c.lng()}),
        p3 = new LatLng({lat:c.lat(), lng:ne.lng()}),
        p4 = new LatLng({lat:c.lat(), lng:sw.lng()})
      const d1 = d(p1, p2),
        d2 = d(p3, p4)
      return Math.min(d1, d2)
    },
    setType(t) {
      switch(t) {
      case 'point':
        switch (this.poi.model[0][0]) {
        case 'circle':
          // remove radius, leave center
          this.poi.model[0].splice(3, 1)
          break
        }
        break
      case 'circle':
        switch (this.poi.model[0][0]) {
        case 'point':
          // keep center, add radius
          this.$set(this.poi.model[0], 3, this.getMinDimension() / 3)
          break
        }
        break
      }
      this.$set(this.poi.model[0], 0, t)
    },
    save() {
      this.$store.dispatch('savePoi', { poi: this.poi, fleet: this.fleet })
    },
    async del() {
      if (!this.poi) return
      if (this.poi.id) {
        await this.$store.dispatch('deletePoi', { poi: this.poi, fleet: this.fleet })
      }
      this.poi = null
    },
  },
  watch: {
    poi(nv) {
      this.$store.commit('selectPoi', nv && nv.id || null)
    },
    selectedPoi(nv) {
      if (this.poi && this.poi.id !== nv) {
        this.$store.commit('selectPoi', this.poi.id)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$bg: #eee;
.poi-settings {
  position: relative;
  > div {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #000;

    display: flex;
    flex-direction: column;

    .config {
      overflow-y: auto;
      flex: 0 1 auto;
      margin-bottom: 1px;
      > div {
        overflow: hidden;
        > div {
          margin: 0 -1px -1px 0;
        }
      }
    }
    .map-el {
      flex: 1 0 auto;
      height: 50%;
    }
  }
}
@media (min-width: 1400px) {
  .poi-settings {
    > div {
      flex-direction: row;
      .config {
        flex: 0 0 auto;
        width: 400px;
        height: 100%;
      }
      .map-el {
        width: 50%;
        height: 100%;
      }
    }
  }
}
.poi-list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  padding: 15px 10px 10px 15px;
  background: $bg;
  margin: 0 1px 1px 0;
  a {
    display: inline-block;
    border-radius: 5px;
    padding: 5px 10px;
    background: #bbb;
    margin: 0 5px 5px 0;
    height: 24px;
    line-height: 24px;
    text-decoration: none;
    &:hover {
      background: #ccc;
    }
    &.selected {
      background: #fff;
    }
    &.add {
      position: relative;
      width: 14px;
      > span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.edit-poi {
  .poi-row {
    display: flex;
    flex-wrap: wrap;
    overflow-y: hidden;
    label {
      flex: 0 0 auto;
      font-size: 20px;
      padding: 0 15px;
      align-self: stretch;
      line-height: 54px;
      overflow: hidden;
      margin: 0 1px 1px 0;
      background: $bg;
    }
    input {
      flex: 1 1 auto;
      font-size: 20px;
      line-height: 54px;
      flex-grow: 1;
      background: #fff;
      outline: none;
      padding: 0 10px;
      align-self: stretch;
      min-width: 200px;
      border: none;
      margin: 0 1px 1px 0;
      &.changed {
        background: #fea;
      }
    }
    div {
      flex: 1 0 auto;
      padding: 10px 0 0 10px;
      margin: 0 1px 1px 0;
      display: flex;
      flex-wrap: wrap;
      background: $bg;
      button {
        background: #bbb;
        font-size: 20px;
        margin: 0 10px 10px 0;
        &:hover {
          background: #ccc;
        }
        &.changed {
          background: #f64;
        }
        &.selected {
          background: #fff;
        }
      }
    }

  }
}
</style>
